import React from "react";
import PropTypes from "prop-types";
import { Tooltip as ReactTooltip } from "react-tooltip";
import MobileDetect from "mobile-detect";

function ToolTip(props, { locals }) {
  const {
    children,
    width,
    className,
    id,
    type,
    body,
    multiline,
    place,
    effect,
    html,
    hintClassNames = "",
    float = true,
  } = props;

  // we never want to show tooltips on mobile, so disable them!
  const md = new MobileDetect(locals.headers["user-agent"] || "");

  return (
    <div className={className}>
      <div
        data-tooltip-content={body}
        data-tooltip-id={id}
        data-tip-disable={md.mobile() ? true : false}
        data-tooltip-html={html || null}
        data-tooltip-place={place || "top"}
      >
        {children}
      </div>
      <ReactTooltip
        id={id}
        // type={type || "dark"}
        multiline={multiline || false}
        float={float}
        className={`React-Tooltip${
          hintClassNames ? ` ${hintClassNames}` : ""
        } custom-style`}
      />
    </div>
  );
}

ToolTip.contextTypes = { locals: PropTypes.object };

export default ToolTip;
